function addImagesFromAttachments(emailBody, attachments) {
    for (let i = 0; i < attachments.length; i++) {
        const attachment = attachments[i];
        emailBody = emailBody.replaceAll(`cid:${attachment.contentId}`, `data:${attachment.mediaType};base64, ${attachment.content}`);
    }
    return emailBody;
}

export default addImagesFromAttachments;